import type { FetchBaseQueryArgs } from "@reduxjs/toolkit/query";

import { getClerkToken } from "~/store/clerkToken";

export const prepareHeaders: NonNullable<
  FetchBaseQueryArgs["prepareHeaders"]
> = async (headers) => {
  const token = await getClerkToken();

  if (token) {
    headers.set("Authorization", `Bearer ${token}`);
  }

  return headers;
};
